const API_URL = (import.meta.env.VITE_API_URL || "https://api-mail.wwmaxik.ru").replace(/\/$/, "");

export class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

async function request(path, options = {}) {
  const headers = new Headers(options.headers);
  if (options.body && !(options.body instanceof FormData)) {
    headers.set("Content-Type", "application/json");
  }

  let response;
  try {
    response = await fetch(`${API_URL}${path}`, { ...options, headers, credentials: "include" });
  } catch {
    throw new ApiError("API недоступен. Проверьте сеть и настройки CORS.", 0);
  }

  if (response.status === 204) return null;
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new ApiError(data?.error || `Ошибка API (${response.status})`, response.status);
  }
  return data;
}

export const api = {
  getSession() {
    return request("/api/auth/session");
  },

  login(password) {
    return request("/api/auth/login", { method: "POST", body: JSON.stringify({ password }) });
  },

  logout() {
    return request("/api/auth/logout", { method: "POST" });
  },

  getTheme() {
    return request("/api/settings/theme");
  },

  updateTheme(theme) {
    return request("/api/settings/theme", { method: "PUT", body: JSON.stringify({ theme }) });
  },

  getInbox({ page = 1, limit = 20, query = "", temp = "" } = {}) {
    const params = new URLSearchParams({ page, limit });
    if (query) params.set("q", query);
    if (temp) params.set("temp", "true");
    return request(`/api/inbox?${params}`);
  },

  getEmail(id) {
    return request(`/api/email/${id}`);
  },

  deleteEmail(id) {
    return request(`/api/email/${id}`, { method: "DELETE" });
  },

  sendEmail(payload) {
    return request("/api/send", { method: "POST", body: JSON.stringify(payload) });
  },

  async downloadAttachment(id, filename) {
    const response = await fetch(`${API_URL}/api/attachment/${id}`, {
      credentials: "include",
    });
    if (!response.ok) {
      const data = await response.json().catch(() => null);
      throw new ApiError(data?.error || "Не удалось скачать вложение", response.status);
    }
    const url = URL.createObjectURL(await response.blob());
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  },
};
